import { reportError } from "../../../../lib/bugReporting";
import {
  formatDollarInput,
  handlePaymentAmountInputChange,
  parseOnEditOrFocus,
} from "../../../../lib/formatting";
import StyledInput from "../../../common/inputs/StyledInput";
import {
  StyledInputLabelProps,
  StyledInputProps,
  StyledInputValidationProps,
} from "../../../common/inputs/StyledInput/StyledInput";

type Props = Omit<StyledInputProps, "value" | "onChange"> & {
  value: string;
  onChange: (v: string) => void;
} & StyledInputLabelProps &
  StyledInputValidationProps;

export default function CheckAmountInput({
  onChange,
  onBlur,
  onFocus,
  ...props
}: Props) {
  return (
    <StyledInput
      {...props}
      onChange={(e) => {
        const val = e.target.value;
        try {
          const parsedVal = parseOnEditOrFocus(val);
          if (parsedVal !== null) {
            onChange(`$${parsedVal}`);
          }
        } catch (err) {
          reportError(
            new Error("Failed to parse payment amount", {
              cause: err,
            }),
          );
          onChange(`$${val}`);
        }
      }}
      onBlur={(e) => {
        /*
            Formatting is different in this onBlur than onChangeText to ensure that final result is fully formatted
            unlike formatting dollar and cents portions individually while user is entering input in the onChangeText function
          */
        try {
          const handledChange = handlePaymentAmountInputChange(props.value);
          if (handledChange) {
            onChange(`$${formatDollarInput(handledChange)}`);
          } else {
            onChange("$0.00");
          }
        } catch (err) {
          reportError(
            new Error("Failed to parse custom input", { cause: err }),
          );
        } finally {
          onBlur?.(e);
        }
      }}
      onFocus={(e) => {
        try {
          parseOnEditOrFocus(props.value);
        } catch (err) {
          reportError(
            new Error("Failed to parse custom input", { cause: err }),
          );
        } finally {
          onFocus?.(e);
        }
      }}
    />
  );
}
